import React from 'react';
import { Link } from 'react-router-dom';

function NotFound() {
    return (
        <div className="container" style={{marginTop: '200px'}}>
            <div className="row justify-content-center">
                <div className="col-md-6 text-center">
                    <h1>404</h1>
                    <h3>페이지를 찾을 수 없습니다.</h3>
                    <p>죄송합니다. 더 이상 존재하지 않는 페이지입니다.</p>
                    <a href="/" className="btn btn-primary">홈으로 이동</a>
                </div>
            </div>
        </div>
    );
}

export default NotFound;
